var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showModal
    ? _c("ModalFullScreen", {
        attrs: { size: "lg" },
        on: { close: _vm.handleCancel },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c("ValidationObserver", [
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.invite()
                          },
                        },
                      },
                      [
                        _c(
                          "ModalContent",
                          [
                            _c("div", { staticClass: "info-icon-wrapper" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "22",
                                    height: "21",
                                    viewBox: "0 0 22 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M11 0C5.20156 0 0.5 4.70156 0.5 10.5C0.5 16.2984 5.20156 21 11 21C16.7984 21 21.5 16.2984 21.5 10.5C21.5 4.70156 16.7984 0 11 0ZM11.75 15.5625C11.75 15.6656 11.6656 15.75 11.5625 15.75H10.4375C10.3344 15.75 10.25 15.6656 10.25 15.5625V9.1875C10.25 9.08438 10.3344 9 10.4375 9H11.5625C11.6656 9 11.75 9.08438 11.75 9.1875V15.5625ZM11 7.5C10.7056 7.49399 10.4253 7.37282 10.2192 7.1625C10.0132 6.95218 9.89773 6.66945 9.89773 6.375C9.89773 6.08055 10.0132 5.79782 10.2192 5.5875C10.4253 5.37718 10.7056 5.25601 11 5.25C11.2944 5.25601 11.5747 5.37718 11.7808 5.5875C11.9868 5.79782 12.1023 6.08055 12.1023 6.375C12.1023 6.66945 11.9868 6.95218 11.7808 7.1625C11.5747 7.37282 11.2944 7.49399 11 7.5Z",
                                      fill: "#1A7BEE",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "info-icon-wrapper-span font-semibold",
                                },
                                [_vm._v("Send invite")]
                              ),
                            ]),
                            _c("p", { staticClass: "table-wrapper" }, [
                              _vm._v(
                                " Great news! You’re one step away from inviting the following resources onto the platform. "
                              ),
                            ]),
                            _c("ContractorTable", {
                              attrs: {
                                isInPopup: true,
                                data: _vm.data,
                                headers: _vm.headers,
                              },
                            }),
                            _c("div", { staticClass: "flex-1" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "flex",
                                  staticStyle: {
                                    "justify-content": "flex-end !important",
                                  },
                                },
                                [
                                  _c("UiButton", {
                                    staticClass: "mr-3",
                                    attrs: {
                                      variant: "outline",
                                      size: "lg",
                                      id: "cancelInviteContractor",
                                      buttonText: "Cancel",
                                    },
                                    on: { click: _vm.handleCancel },
                                  }),
                                  _c("UiButton", {
                                    attrs: {
                                      type: "submit",
                                      size: "lg",
                                      variant: "black",
                                      buttonClasses: "customPadding w-auto",
                                      id: "inviteContractorButton",
                                      disabled: !_vm.data.length || _vm.loading,
                                      buttonText:
                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t Invite\n\t\t\t\t\t\t\t\t\t\t\t\t",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1558072305
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }